<template>
<div class="chapter">
<div class="inner_page">
<a id="page_5">
<h1 class="tochead">CONTENTS</h1>
</a><h2 class="toc_chap1"><a id="page_5"></a><a href="#/xhtml/05_Acknowledgements">Acknowledgements</a></h2>
<h2 class="toc_chap1"><a href="#/xhtml/06_Introduction">Introduction</a></h2>
<h2 class="toc_chapt"><a href="#/xhtml/07_Chapter_1"><span class="tochang">Chapter 1</span> Administration of the Regiment</a></h2>
<h2 class="toc_chap"><a href="#/xhtml/08_Chapter_2"><span class="tochang">Chapter 2</span> <em class="italic">Grenadiers-à-Cheval</em></a></h2>
<h2 class="toc_chap"><span href="#/xhtml/10_Chapter_3" title="Link target outside of Sample"><span class="tochang">Chapter 3</span> <em class="italic">Chasseurs-à-Cheval</em></span></h2>
<h2 class="toc_chap"><span href="#/xhtml/11_Chapter_4" title="Link target outside of Sample"><span class="tochang">Chapter 4</span> The <em class="italic">Mamelukes</em></span></h2>
<h2 class="toc_chap"><span href="#/xhtml/12_Chapter_5" title="Link target outside of Sample"><span class="tochang">Chapter 5</span> Empress Dragoons</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/13_Chapter_6" title="Link target outside of Sample"><span class="tochang">Chapter 6</span> Polish Lancers</span></h2>
<h2 class="toc_chaptb"><span href="#/xhtml/14_Plates" title="Link target outside of Sample">Keith Rocco Colour Plates</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/15_Chapter_7" title="Link target outside of Sample"><span class="tochang">Chapter 7</span> Dutch Lancers</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/16_Chapter_8" title="Link target outside of Sample"><span class="tochang">Chapter 8</span> Lithuanian Lancers and Tatars</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/17_Chapter_9" title="Link target outside of Sample"><span class="tochang">Chapter 9</span> <em class="italic">Éclaireurs</em></span></h2>
<h2 class="toc_chap"><span href="#/xhtml/18_Chapter_10" title="Link target outside of Sample"><span class="tochang">Chapter 10</span> Elite <em class="italic">Gendarmes</em></span></h2>
<h2 class="toc_chap"><span href="#/xhtml/19_Chapter_11" title="Link target outside of Sample"><span class="tochang">Chapter 11</span> Horse Artillery</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/20_Chapter_12" title="Link target outside of Sample"><span class="tochang">Chapter 12</span> Artillery Train</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/21_Chapter_13" title="Link target outside of Sample"><span class="tochang">Chapter 13</span> Equipment Train</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/22_Chapter_14" title="Link target outside of Sample"><span class="tochang">Chapter 14</span> <em class="italic">Gendarmes d’Ordonnance</em></span></h2>
<h2 class="toc_chap"><span href="#/xhtml/23_Chapter_15" title="Link target outside of Sample"><span class="tochang">Chapter 15</span> Attached Regiments</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/24_Chapter_16" title="Link target outside of Sample"><span class="tochang">Chapter 16</span> Royal Corps of Cavalry</span></h2>
<h2 class="toc_chap1t"><span href="#/xhtml/25_Glossary" title="Link target outside of Sample">Glossary of Uniforms</span></h2>
<h2 class="toc_chap1"><span href="#/xhtml/26_Bibliography" title="Link target outside of Sample">Bibliography</span></h2>
<h2 class="toc_chap1"><span href="#/xhtml/27_Endnotes" title="Link target outside of Sample">Endnotes</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?57d17edb